import store from "../../store";
import { MARKET_DEPTH_STREAMING, SCRIP_CLEAR_DATA, SCRIP_DETAILS_STREAMING, SECRIP_DETAIL, SECRIP_DETAIL_ERROR, SECRIP_DETAIL_HIDE_ERROR, SECRIP_DETAIL_START_LOADER, SECRIP_DETAIL_STOP_LOADER, } from "../../interfaces/common/ScripDetail";
var ScripDetailActions = /** @class */ (function () {
    function ScripDetailActions() {
        this.dispatch = store.dispatch;
    }
    ScripDetailActions.prototype.getMarketDepthStreamData = function (data) {
        this.dispatch({
            type: MARKET_DEPTH_STREAMING,
            payload: { marketDepthStream: data },
        });
    };
    ScripDetailActions.prototype.getScripDetailData = function (data) {
        this.dispatch({
            type: SECRIP_DETAIL,
            payload: { data: data },
        });
    };
    ScripDetailActions.prototype.getScriptDetailStreamData = function (data) {
        this.dispatch({
            type: SCRIP_DETAILS_STREAMING,
            payload: { qouteStream: data },
        });
    };
    ScripDetailActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: SECRIP_DETAIL_ERROR,
            payload: { errorData: payload },
        });
    };
    ScripDetailActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: SECRIP_DETAIL_HIDE_ERROR,
        });
    };
    ScripDetailActions.prototype.startLoader = function () {
        this.dispatch({
            type: SECRIP_DETAIL_START_LOADER,
        });
    };
    ScripDetailActions.prototype.stopLoader = function () {
        this.dispatch({
            type: SECRIP_DETAIL_STOP_LOADER,
        });
    };
    ScripDetailActions.prototype.clearData = function () {
        this.dispatch({
            type: SCRIP_CLEAR_DATA,
        });
    };
    return ScripDetailActions;
}());
export default ScripDetailActions;
